import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
const _excluded = ["className", "style", "value", "isHighlighted", "onCreate"];
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '@adsk/alloy-react-button';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { useTranslation } from '../../i18n';
const CreateNewMenuItem = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      className,
      style,
      value,
      isHighlighted,
      onCreate
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(_StyledLi, _extends({
    ref: ref,
    className: className
  }, props, {
    $_css: [_objectSpread(_objectSpread({
      display: 'flex',
      alignItems: 'flex-start',
      padding: "".concat(theme.spacing.XS, "px ").concat(theme.spacing.M, "px"),
      cursor: 'pointer'
    }, isHighlighted && {
      backgroundColor: theme.tokens.colors.background.neutral.hover.value
    }), {}, {
      '&:active': {
        backgroundColor: theme.tokens.colors.background.neutral.pressed.value
      }
    }), style]
  }), /*#__PURE__*/React.createElement(LinkButton, {
    onClick: e => {
      onCreate === null || onCreate === void 0 ? void 0 : onCreate(value, e);
    }
  }, /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css2: [theme.typography.ellipsis]
  }, t('CREATE_OPTION', {
    label: value
  }))));
});
CreateNewMenuItem.displayName = 'CreateNewMenuItem';
CreateNewMenuItem.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  value: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool,
  onCreate: PropTypes.func
};
export default CreateNewMenuItem;
var _StyledLi = _styled("li")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledSpan = _styled2("span").withConfig({
  displayName: "CreateNewMenuItem___StyledSpan",
  componentId: "sc-cpxciy-0"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=CreateNewMenuItem.js.map